import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { queryClient } from "..";

export default function useFetchData(
  cache_key,
  fetchFunction,
  dependencies = []
) {
  const [page, setPage] = useState(1);

  const { isFetching, isLoading, data, refetch } = useQuery(
    [cache_key, page, ...dependencies],
    () => fetchFunction(page, ...dependencies),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      staleTime: 0,
    }
  );

  // Prefetch the next page!
  useEffect(() => {
    const hasNext = data?.data?.data?.hasNextPage || data?.data?.logs?.hasNextPage;
    if (hasNext) {
      queryClient.prefetchQuery([cache_key, page + 1, ...dependencies], () =>
        fetchFunction(page + 1, ...dependencies)
      );
    }
  }, [data, page, ...dependencies, fetchFunction, cache_key]);

  return {
    // INTERNAL EXPORTS
    page,
    setPage,
    // REACT QUERY EXPORTS
    isFetching,
    isLoading,
    data,
    refetch,
  };
}
